import { useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import ApButton from "components/Shared/ApButton";
import ShiptoDetail from "./ShipToDetail";
import ShiptoHeader from "./ShipToHeader";
import { ApButtonStyle4 } from 'models/ButtonStyles';
import ShiptoPopup from "./ShipToPopup";
import useOnClickOutside from "hooks/useOnClickOutside";
import { useShipTo } from "contexts/ShipToProvider";
import { FormattedMessage } from "react-intl";

const ShiptoSelect = () => {
    const ref = useRef(null);
    const [collapse, setCollapse] = useState(true);
    const [popupShow, setPopupShow] = useState(false);
    const { selectedShipTo } = useShipTo();
    const currentShipTo = selectedShipTo() ?? {};
    useOnClickOutside([ref], () => setCollapse(true));
    const defaultHeight: number = 40,
        defaultHeaderStyle = {
            height: `${defaultHeight}px`
        },
        defaultDetailStyle = {
            transform: `translate(0px, ${defaultHeight}px)`,
            display: collapse ? 'none' : 'block'
        };
    const activeClass = () => collapse ? "" : "active";
    const arrowClass = () => collapse ? "down" : "up";
    //const changeBtnStyle = { ...btnStyleOption_BNN, className: "ms-5 btn-change-shipto" };
    const changeBtnClicked = (event: any) => {
        event.stopPropagation();
        setPopupShow(true);
    };


    return <>
        <div ref={ref} className="shipto-select-container">
            <ShiptoHeader
                style={defaultHeaderStyle}
                className={`shipto-select-header ps-4 ${activeClass()}`}
                onClick={() => setCollapse(!collapse)}>
                <Row>
                    <Col md={5}><FormattedMessage id="ml_114710" defaultMessage="X - Selected Ship To"/></Col>
                    <Col md={3} className="ap-green">{currentShipTo.shipToNumber}</Col>
                    <Col>
                        <Row>
                            <Col className="text-end"><i className={`arrow ${arrowClass()}`}></i></Col>
                            <Col md="auto"><input type="button" className="btn-change-shipto float-end" value="Change" onClick={changeBtnClicked} /></Col>
                        </Row>
                    </Col>
                </Row>
            </ShiptoHeader>
            <ShiptoDetail style={defaultDetailStyle} className={`shipto-select-detail ps-4 pt-3 pb-3 ${activeClass()}`} display={!collapse} shipTo={currentShipTo} />
            <ShiptoPopup show={popupShow} onHide={() => setPopupShow(false)} keyboard={false} autoFocus={true}></ShiptoPopup>
        </div>
    </>;
};
export default ShiptoSelect;